import { render, staticRenderFns } from "./AddressAutocomplete.vue?vue&type=template&id=995090d4&scoped=true"
import script from "./AddressAutocomplete.vue?vue&type=script&lang=js"
export * from "./AddressAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./AddressAutocomplete.vue?vue&type=style&index=0&id=995090d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995090d4",
  null
  
)

export default component.exports